
import React from 'react';
import { EquiForgeBrochure } from '@/components/brochure';
import SEOHead from '@/components/seo/SEOHead';

const Brochure: React.FC = () => {
  return (
    <>
      <SEOHead
        title="EquiForge Digital Brochure — Features & Platform Overview"
        description="Explore EquiForge's complete suite of mortgage calculators, AI-powered real estate analytics, SmartBuy deal analyzer, and CLARA AI homebuyer assistant."
        keywords="real estate software, mortgage planning tools, homebuyer platform, real estate analytics brochure, EquiForge features"
        canonicalPath="/brochure"
      />
      <EquiForgeBrochure />
    </>
  );
};

export default Brochure;
